import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "react-feather";
import i18n from "~/assets/js/Helpers/i18n";
import IntoleranceFilterOptions from "./component/IntoleranceFilterOptions";
import useClickOutside from "~/assets/js/Helpers/hooks/useClickOutside";
import { IntoleranceFiltersTypes } from "./types";

const IntoleranceFilter = ({ intolerances, onFilter, activeIntolerances }) => {
    const [open, setOpen] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState([]);

    // Sync with global state
    useEffect(() => {
        setSelectedFilters(
            intolerances
                .filter((i) => activeIntolerances.includes(i.id))
                .map((i) => i.id)
        );
        return () => setSelectedFilters([]);
    }, [open]);

    const toggleSelected = (intoleranceId) => {
        if (selectedFilters.includes(intoleranceId)) {
            setSelectedFilters(
                selectedFilters.filter((filter) => filter !== intoleranceId)
            );
            return;
        }
        setSelectedFilters([...selectedFilters, intoleranceId]);
    };

    const clearFilters = () => setSelectedFilters([]);
    const closeDropdown = () => setOpen(false);
    const ref = useRef();
    useClickOutside(ref, closeDropdown);

    return (
        <>
            <div className="intolerance-filter_container" ref={ref}>
                <div
                    className={`intolerance-filter ${
                        activeIntolerances.length
                            ? "intolerance-filter--active"
                            : ""
                    }`}
                    onClick={() => setOpen(!open)}
                >
                    <p className="intolerance-filter_text">
                        {i18n.t("intoleranceFilters.placeholder")}
                    </p>
                    <div className="intolerance-filter__icons-wrapper">
                        {!!selectedFilters.length && (
                            <p className="intolerance-filter_count">
                                {selectedFilters.length}
                            </p>
                        )}
                        <ChevronDown size={24} className={open ? "open" : ""} />
                    </div>
                </div>
                <IntoleranceFilterOptions
                    open={open}
                    onSelect={toggleSelected}
                    handleClose={closeDropdown}
                    handleClear={clearFilters}
                    selectedFilters={selectedFilters}
                    intolerances={intolerances}
                    onFilter={onFilter}
                />
            </div>
        </>
    );
};

export default IntoleranceFilter;

IntoleranceFilter.propTypes = IntoleranceFiltersTypes;
